'use strict';

export const AUTO_LIST_NAME = 'autoPriorities';
export const AUTO_LIST_PREFIX = `@@${AUTO_LIST_NAME}`;
export const PINNED_LIST_NAME = 'pinnedPriorities';
export const PINNED_LIST_PREFIX = `@@${PINNED_LIST_NAME}`;
export const PRIORITY_EXPORTS_NAME = 'priorityExports';
export const PRIORITY_EXPORTS_PREFIX = `@@${PRIORITY_EXPORTS_NAME}`;



// WEBPACK FOOTER //
// ./src/js/priorities/redux/state.js